module.exports = __webpack_public_path__ + "static/media/item_2_1ll.38c48055.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_1ll.png
// module id = 118
// module chunks = 0